var map = {
	"./AOnePerson.png": "2639",
	"./add.png": "5c19",
	"./ai.png": "7439",
	"./ai_icon.png": "346f",
	"./arrows_home.png": "79a0",
	"./back.png": "07bb",
	"./background-img.png": "6c6e",
	"./call.png": "5bc8",
	"./change.png": "630e",
	"./chat-func-btn-icon/dianhuagoutong.png": "22a5",
	"./chat-func-btn-icon/gengduo.png": "8e5e",
	"./chat-func-btn-icon/kaichufang.png": "7fdd",
	"./chat-func-btn-icon/kuaijiehuifu.png": "720a",
	"./chat-func-btn-icon/paishe.png": "b7e7",
	"./chat-func-btn-icon/referral.png": "fe9c",
	"./chat-func-btn-icon/shipingoutong.png": "5ed9",
	"./chat-func-btn-icon/shouqi.png": "fde8",
	"./chat-func-btn-icon/shuangyue.png": "9ce9",
	"./chat-func-btn-icon/tuihao.png": "abe1",
	"./chat-func-btn-icon/writeReport.png": "7bf1",
	"./chat-func-btn-icon/xiebingli.png": "fde5",
	"./chat-func-btn-icon/zhaopian.png": "9199",
	"./chat-func-btn-icon/zhenliao.png": "3c98",
	"./checkout.png": "1206",
	"./checkoutDefault.png": "114c",
	"./chineseDefault1.png": "f91a",
	"./chineseHerbal.png": "14d4",
	"./chineseHerbalDefault.png": "b744",
	"./chineseMedicine.png": "7fa4",
	"./chineseMedicine1.png": "9e6e",
	"./close.png": "57cd",
	"./default-user-photo.png": "b0b9",
	"./default/no-content.png": "a93d",
	"./defaultUser.png": "01bb",
	"./delete.png": "0bd6",
	"./deleteDrug.png": "5c33",
	"./delete_diag.png": "3e5e",
	"./delete_member.png": "9f85",
	"./delete_tag.png": "8a65",
	"./ding.png": "b434",
	"./doctorStationed/add-icon.png": "f740",
	"./doctorStationed/arrow2.png": "da75",
	"./doctorStationed/bg.png": "e0b5",
	"./doctorStationed/bg1.png": "fa2e",
	"./doctorStationed/bg2.png": "85c6",
	"./doctorStationed/camera.png": "8afe",
	"./doctorStationed/card1.png": "f471",
	"./doctorStationed/card2.png": "2300",
	"./doctorStationed/card3.png": "9e5f",
	"./doctorStationed/card4.png": "e9b4",
	"./doctorStationed/card5.png": "eab6",
	"./doctorStationed/card6.png": "a222",
	"./doctorStationed/d_icon.png": "59bb",
	"./doctorStationed/icon.png": "cb2c",
	"./doctorStationed/no-content.png": "36a7",
	"./doctorStationed/right.png": "838b",
	"./file_icon.png": "fb44",
	"./filtrate.png": "6e3b",
	"./filtratePng.png": "d04f",
	"./grouping.png": "b1c2",
	"./high.png": "4fbe",
	"./history_bg.png": "c96c",
	"./history_long_bg.png": "b214",
	"./hook.png": "34c6",
	"./icon/icon-error-circle.png": "cda3",
	"./icon/icon-success-circle.png": "684f",
	"./icon_1.png": "9f8f",
	"./icon_1_activted.png": "2bbf",
	"./icon_2.png": "edf1",
	"./icon_2_activted.png": "ff96",
	"./info_bg.png": "5713",
	"./inspect.png": "d499",
	"./inspectDefault.png": "f150",
	"./invite.png": "420c",
	"./invitePatients.png": "c0a8",
	"./invite_patient.png": "7620",
	"./leadingTwo.png": "35fe",
	"./loading.png": "d40b",
	"./login.png": "d150",
	"./love.png": "a00d",
	"./low.png": "7b85",
	"./man.png": "93c1",
	"./mongolianDefault1.png": "c978",
	"./mongolianMedicine1.png": "5080",
	"./multipleSend.png": "683c",
	"./myAccount.png": "a972",
	"./myAccountBtn.png": "d799",
	"./myAttention.png": "104a",
	"./myInformation.png": "a4a7",
	"./myPatients.png": "5fbc",
	"./my_account.png": "643a",
	"./navigation.png": "48b1",
	"./new_search.png": "a67d",
	"./next.png": "a6af",
	"./noPicture.png": "63f4",
	"./onePersonDefault.png": "de34",
	"./onePersonPre.png": "5875",
	"./open.png": "8c9e",
	"./particle.png": "4269",
	"./particleDefault.png": "e49d",
	"./patient_home_page.png": "d797",
	"./patient_info.png": "c135",
	"./pouchPack.png": "e1ae",
	"./pouchPackDefault.png": "c555",
	"./pyq.png": "ba96",
	"./redDelete.png": "d1b4",
	"./red_right.png": "e5ab",
	"./register.png": "c04d",
	"./search.png": "6061",
	"./selectedfiltrate.png": "a7aa",
	"./service.png": "35ac",
	"./service_managa.png": "a3bb",
	"./share_copy.png": "02e1",
	"./ssss_active.png": "7dbd",
	"./ssss_default.png": "7137",
	"./tip.png": "428b",
	"./toLead.png": "c0cd",
	"./trapezoid.png": "5749",
	"./treat.png": "a644",
	"./treatDefault.png": "8b14",
	"./triangle.png": "59ce",
	"./userCenter.png": "aef4",
	"./western1.png": "cf73",
	"./westernDefault1.png": "394c",
	"./westernMedicine.png": "5aee",
	"./woman.png": "2045",
	"./wx.png": "c5c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fba8";